module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/symbol-observable/index.js
 ** module id = 478
 ** module chunks = 0
 **/